import { useCallback } from "react";
import type { QueryClient } from "@tanstack/react-query";

import type { PlaceDetails } from "./google-places";

export const usePlacesCache = (queryClient: QueryClient) => {
  const getCachedPlaceDetails = useCallback(
    (placeId: string): PlaceDetails | null => {
      return queryClient.getQueryData([`place-details-${placeId}`]) || null;
    },
    [queryClient]
  );

  const getCachedOriginalText = useCallback(
    (placeId: string): string | null => {
      return queryClient.getQueryData([`place-text-${placeId}`]) || null;
    },
    [queryClient]
  );

  const cachePlaceDetails = useCallback(
    (placeId: string, details: PlaceDetails) => {
      queryClient.setQueryData([`place-details-${placeId}`], details);
    },
    [queryClient]
  );

  const cacheOriginalText = useCallback(
    (placeId: string, text: string) => {
      queryClient.setQueryData([`place-text-${placeId}`], text);
    },
    [queryClient]
  );

  return {
    getCachedPlaceDetails,
    getCachedOriginalText,
    cachePlaceDetails,
    cacheOriginalText,
  };
};
